import React from "react";
import { PaymentSummary as PaymentSummaryType, } from "./dashboardType";


interface Props {
  data: PaymentSummaryType;
}

const currency = (
  value: number
) =>
  new Intl.NumberFormat(
    "en-IN",
    {
      style: "currency",
      currency: "INR",
      maximumFractionDigits: 2,
    }
  ).format(value || 0);

const PaymentSummary: React.FC<Props> = ({
  data,
}) => {
  return (
    <section className="rounded-xl border bg-white p-5 shadow-sm">
      <h2 className="mb-4 text-lg font-semibold">
        Payments
      </h2>

      <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
        <div className="rounded-lg bg-gray-50 p-4">
          <p className="text-sm text-gray-500">
            Collected
          </p>
          <p className="mt-1 text-xl font-bold">
            {currency(data.Collected)}
          </p>
        </div>

        <div className="rounded-lg bg-gray-50 p-4">
          <p className="text-sm text-gray-500">
            Pending
          </p>
          <p className="mt-1 text-xl font-bold">
            {currency(
              data.Pending_Amount
            )}
          </p>
        </div>

        <div className="rounded-lg bg-gray-50 p-4">
          <p className="text-sm text-gray-500">
            Failed
          </p>
          <p className="mt-1 text-xl font-bold">
            {currency(
              data.Failed_Amount
            )}
          </p>
        </div>

        <div className="rounded-lg bg-gray-50 p-4">
          <p className="text-sm text-gray-500">
            Transactions
          </p>
          <p className="mt-1 text-xl font-bold">
            {data.Transactions}
          </p>
        </div>
      </div>

      <div className="mt-5">
        <h3 className="mb-3 font-medium">
          Transaction Status
        </h3>

        <div className="grid grid-cols-3 gap-4">
          <div>
            <p className="text-sm text-gray-500">
              Successful
            </p>
            <p className="font-bold">
              {data.Success_Transactions}
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-500">
              Pending
            </p>
            <p className="font-bold">
              {data.Pending_Transactions}
            </p>
          </div>

          <div>
            <p className="text-sm text-gray-500">
              Failed
            </p>
            <p className="font-bold">
              {data.Failed_Transactions}
            </p>
          </div>
        </div>
      </div>

      <div className="mt-5">
        <h3 className="mb-3 font-medium">
          Payment Methods
        </h3>

        {data.Payment_Methods.length ===
        0 ? (
          <p className="text-sm text-gray-500">
            No payment methods found.
          </p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-left text-sm">
              <thead>
                <tr className="border-b">
                  <th className="px-3 py-2">
                    Method
                  </th>

                  <th className="px-3 py-2">
                    Count
                  </th>

                  <th className="px-3 py-2">
                    Amount
                  </th>
                </tr>
              </thead>

              <tbody>
                {data.Payment_Methods.map(
                  (item) => (
                    <tr
                      key={
                        item.Payment_Method
                      }
                      className="border-b"
                    >
                      <td className="px-3 py-2">
                        {item.Payment_Method}
                      </td>

                      <td className="px-3 py-2">
                        {item.Count}
                      </td>

                      <td className="px-3 py-2 font-medium">
                        {currency(
                          item.Amount
                        )}
                      </td>
                    </tr>
                  )
                )}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export default PaymentSummary;